import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-center-point',
  templateUrl: './center-point.component.html',
  styleUrls: ['./center-point.component.scss']
})
export class CenterPointComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
